import { BaseAction, DataAction } from '../commons'

export const SSO_LOGIN = 'SSO_LOGIN/LOGIN'
export const SSO_LOGIN_FAIL = 'SSO_LOGIN/FAIL'
export const SSO_HANDLE_CALLBACK = 'SSO_LOGIN/HANDLE_CALLBACK'

export interface SSOCallbackData {
  isLoggedIn: boolean
  isSubmitting: boolean
}

export const ssoLogin = (): BaseAction => ({ type: SSO_LOGIN })

export const ssoLoginFail = (error?: string): DataAction<{ error?: string }> => ({
  type: SSO_LOGIN_FAIL,
  data: { error },
})

export const ssoHandleCallback = (callbackData: SSOCallbackData): DataAction<SSOCallbackData> => ({
  type: SSO_HANDLE_CALLBACK,
  data: callbackData,
})
